import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "/plans/subscriptions/user/dommus";

export class UseService extends BaseService {
  async listAvailableUsers(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get(`${URL}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async addUserToPlan(partnerId: string | number): Promise<any[]> {
    try {
      return this.handleResponse(
        await api.post("/plans/subscriptions/user/add", { partner_id: String(partnerId) })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getMessageBalance(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get("/users/message-balance"));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getActiveSubscription(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get("/users/active-subscription"));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listDependents(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get("/users/list/dependent"));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async removeUser(userId: string | number): Promise<any[]> {
    try {
      const response = await api.post("/plans/unsubscriptions/user/remove", { user_id: Number(userId) });
      if (response.data?.status === false) {
        return [undefined, response.data?.message || "Erro ao remover usuário"];
      }
      return this.handleResponse(response);
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async cancelRemoval(userId: string | number): Promise<any[]> {
    try {
      const response = await api.post("/plans/unsubscriptions/user/revoke", { user_id: Number(userId) });
      if (response.data?.status === false) {
        return [undefined, response.data?.message || "Erro ao cancelar remoção"];
      }
      return this.handleResponse(response);
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}